import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { Match } from "../types";

export const useMatch = (matchId: string | undefined) => {
  const [data, setData] = useState<Match | undefined>();
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!matchId) {
      setLoading(false);
      setNotFound(true);
      return;
    }

    setLoading(true);
    setNotFound(false);

    const unsub = onSnapshot(
      doc(db, "match", matchId),
      (snapshot) => {
        if (snapshot.exists()) {
          setData(snapshot.data() as Match);
          setNotFound(false);
        } else {
          setData(undefined);
          setNotFound(true);
        }
        setLoading(false);
      }
    );

    return unsub;
  }, [matchId]);

  return { data, loading, notFound };
};
